var widgetPie = {
    trackColor: 'rgba(255,255,255,0.25)',
    barColor: 'rgba(255,255,255, 1)',
    scaleLength: 7,
    scaleColor: 'rgba(255,255,255,0.25)',
    size: 160,
    lineWidth: 5
};